import React, { useEffect } from 'react';
import './Preloading.css'
import img1 from '../../Assets/Images/loading img1.png'
import logo1 from '../../Assets/Images/logo1.png'
import logo2 from '../../Assets/Images/logo2.png'


const Preloading = () => {

  return (

    <div className="loading">

      <img src={img1} className="wavySplash" />

      <div className="logo">
        <img src={logo1} className="img1" />
        <img src={logo2} className="img2" />
      </div>
    </div>
  );
}

export default Preloading;